// extracted by mini-css-extract-plugin
export default {"wrapper":"Q2-z","play":"R2-z"};